export default __webpack_public_path__ + "static/media/gy.ddfa83e3.svg";